import { StreamData } from 'types/streamData'
import { FieldResolver } from './fieldResolver'
import { Metadata } from '../adaptor/metadata'

const photoUserTagsResolver: FieldResolver = (metadata: Metadata) =>
  ({ photoUserTags: metadata.getPhotoUserTags() } as StreamData)

export default photoUserTagsResolver
